import React, { useEffect } from 'react'
import { useRiskData, useVehicle, useScheme, useQuote } from 'hooks'
import { formatPolicyDateTime } from 'utils/dates'
import VehicleReg from 'components/VehicleReg'
import {
  DefinitionList,
  DescStyled,
  TermStyled,
} from 'components/@common/DefinitionList'
import { trackAmplitudeEvent } from 'utils/analytics-helpers'

interface PolicyDetailsProps {
  policyId: number
}

export const PolicyDetails = ({ policyId }: PolicyDetailsProps) => {
  const { riskData } = useRiskData()
  const { vehicle } = useVehicle()
  const { scheme } = useScheme()
  const { quote } = useQuote()

  const policyStart = formatPolicyDateTime(riskData.PolicyStartDate.value ?? '')
  const policyEnd = formatPolicyDateTime(riskData.PolicyEndDate ?? '')

  useEffect(() => {
    trackAmplitudeEvent('policy_displayed', {
      quote_id: riskData.QuoteId,
      product_type: vehicle.selected.VehicleType,
      scheme: scheme,
      policy_id: policyId,
      reference_number: quote.ReferenceNumber,
    })
  }, [])

  return (
    <DefinitionList>
      <TermStyled>Registration number</TermStyled>
      <DescStyled>
        <VehicleReg reg={vehicle.selected.RegistrationNumber} />
      </DescStyled>
      <TermStyled>Vehicle description</TermStyled>
      <DescStyled>
        {vehicle.selected.Make} {vehicle.selected.Model}
      </DescStyled>
      <TermStyled>Policy start date and time</TermStyled>
      <DescStyled>{policyStart}</DescStyled>
      <TermStyled>Policy end date and time</TermStyled>
      <DescStyled>{policyEnd}</DescStyled>
      <TermStyled>Policy reference number</TermStyled>
      <DescStyled>{policyId}</DescStyled>
    </DefinitionList>
  )
}
